module.exports = __webpack_public_path__ + "static/hail-c203f8f83222bb0e9c19c8896de7ba0b.png";